<div mat-dialog-content>
  <h3>Mapeo de Campos</h3>
  <p>
    Revisa los campos fijos de la BD y el nombre detectado del Excel.
    Si modificas alguno, ese campo se quitará de la sección "Campos nuevos".
  </p>

  <!-- Sección de campos existentes -->
  <h4>Campos existentes en la BD</h4>
  <table style="width:100%; border-collapse: collapse; margin-bottom: 1rem;">
    <thead>
      <tr>
        <th style="text-align: left; padding: 5px; border-bottom: 1px solid #ccc;">Campo en BD</th>
        <th style="text-align: left; padding: 5px; border-bottom: 1px solid #ccc;">Campo en Excel</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let mapping of fieldMappingsExisting; let i = index">
        <td style="padding: 5px;">{{ mapping.dbField }}</td>
        <td style="padding: 5px;">
          <input matInput [(ngModel)]="mapping.excelField" (ngModelChange)="updateNewFields()" placeholder="Campo del Excel">
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Sección de campos nuevos -->
  <h4>Campos nuevos del Excel</h4>
  <table style="width:100%; border-collapse: collapse;">
    <thead>
      <tr>
        <th style="text-align: left; padding: 5px; border-bottom: 1px solid #ccc;">Campo en Excel</th>
        <th style="text-align: left; padding: 5px; border-bottom: 1px solid #ccc;">Nombre a crear</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let mapping of fieldMappingsNew">
        <td style="padding: 5px;">{{ mapping.excelField }}</td>
        <td style="padding: 5px;">
          <input matInput [(ngModel)]="mapping.newFieldName" placeholder="Nuevo nombre para el campo">
        </td>
      </tr>
    </tbody>
  </table>

  <p><strong>Número total de filas:</strong> {{ data.totalRows }}</p>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="closeDialog()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="importData()">Importar</button>
</div>
